module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNGOEM0MzMiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNERTNCMzAiIGQ9Ik0xMjggMzh2ODlsLTEgMUgzOGw5MC05MHoiLz48cGF0aCBmaWxsPSIjREUzQjMwIiBkPSJNMSAwaDg5TDAgOTBWMWwxLTF6Ii8+PHRleHQgZmlsbD0iI0ZGRkZGRiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjY0Ij48dHNwYW4geD0iMjEiIHk9Ijg1Ij5FUzwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/language-icons/icons/es.svg
// module id = Q5hG
// module chunks = 1